import useIdToFindResourceList from '@/views/creative/utils/use-id-to-find-resource-list.js'

export default {
  computed: {
    resourceList() {
      return useIdToFindResourceList({
        resource: this.templateConfig.resource,
        id: this.category.id
      }) || []
    },

    defaultResource() {
      return this.resourceList.find(item => item.is_default === 1)
    },

    basicResource() {
      return this.resourceList.find(item => item.is_basic === 1)
    },

    resourceMetaData() {
      return this.basicResource.extra || null
    }
  }
}
